<app-specific-questionnaire
  [title]="'TGA.Questionnaire.GeneralQuestions.label' | translate"
  [questions]="generalQuestions()"
  (answersUpdated)="answersUpdated($event)"
  [readOnly]="isCropYearReadOnly()"
  [cropField]="cropField"
  [cropYear]="cropYear"
></app-specific-questionnaire>
